module.exports = __webpack_public_path__ + "static/img/level2_link_img.d1b235a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/level2_link_img.png
// module id = T9LD
// module chunks = 0